import Pages from '@pages';
import { pushRoute } from '../../store/thunks/route.thunk';
import { store } from '../../store/store';

function goToCorner(id: string, title: string) {
  if (id) {
    store.dispatch(
      pushRoute({
        route: { Page: Pages.CORNER },
        params: { current: { id, title }, push: true },
      })
    );
  }
}

export default goToCorner;
